import React, { forwardRef } from 'react';

type ScrollOffsetAnchorProps = {
  offset: number;
  children?: React.ReactNode;
};

const ScrollOffsetAnchor = forwardRef<HTMLDivElement, ScrollOffsetAnchorProps>(
  ({ children, offset }, ref) => (
    <div ref={ref} style={{ top: `${offset}px`, position: 'absolute', zIndex: -1 }}>
      {children}
    </div>
  )
);

// Set the displayName for the component
ScrollOffsetAnchor.displayName = 'ScrollOffsetAnchor';

export default ScrollOffsetAnchor;
